import React from 'react';
import { Spin } from 'antd';
import { isEqual, isEmpty } from 'lodash'; 
import {WeaErrorPage, WeaTools, WeaTable, WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
const { ls } = WeaTools;
import Title from './Title';
import { formatData } from '../../util/common';
//内容组件
class CooperationCom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabdata: props.edata.data,
            currentTab: props.edata.currenttab,
            refresh: false,
        }
        this.handleTabData = this.handleTabData.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if(!isEqual(nextProps, this.props)){
            this.setState({
                tabdata: nextProps.edata.data,
                currentTab: nextProps.edata.currenttab,
                refresh: false,
            }); 
        }
    }
    shouldComponentUpdate(nextProps, nextState){
        return !isEqual(this.state, nextState) || !isEqual(this.props, nextProps)
    }
    componentDidMount(){
        this.props.onRef(this);
    }
    handleTabData(tabid){
        const { params, isremembertab } = this.props.config;
        const { currentTab } = this.state;
        const tabdata_local = ls.getJSONObj('tabdata-' + params.eid + '-' + tabid);
        this.setState({
            refresh: tabid === currentTab,
            currentTab: tabid,
            tabdata: tabdata_local == null ? {} : tabdata_local,
        });
        WeaTools.callApi('/api/portal/element/cooperationtab', 'POST', {...params, tabid}).then(result => {
            ls.set('tabdata-' + params.eid + '-' + tabid, result);
            if(tabid === this.state.currentTab){
                this.setState({
                    tabdata: result,
                    refresh: false,
                });
                if(isremembertab){
                    let edata = ls.getJSONObj('edata-' + params.eid);
                    if(edata){
                        edata.currenttab = tabid;
                        edata.data = result;
                        ls.set('edata-' + params.eid, edata);
                    }
                }
            }
       });
    }
    render() {
        const { config, edata, handleRefresh, handleDelete, fontSizeMp } = this.props;
        const { tabdata, currentTab, refresh } = this.state; 
        const { tabids, titles, esetting } = edata;
        let { fontStyle } = config.item;
        if(!isEmpty(fontSizeMp)) fontStyle = fontSizeMp;
        const { datas={} } = tabdata;
        const { dataColoums=[] } = datas;
        esetting.dataColoums = dataColoums;
        esetting.fontStyle = fontStyle;
        const { eid } = config.params;
        const { contentview = {} } = config.item;
        const cstyle = tabids && tabids.length > 1 && contentview.style && contentview.style.height ? {height: parseInt(contentview.style.height)-32+"px",overflow: "auto"} : {};
        let contentHtml = <div/>;
        let viewType= '0';
        let typeid = '0';
        let status = '0';
        let jointype = '0';
        if(tabdata){
            if( !$.isEmptyObject(tabdata) && tabdata.datas.coworkList){
               contentHtml = <WeaTable columns = {formatData(tabdata.datas.coworkList[0], esetting)} showHeader={esetting.showHeader=='1'} pagination={false} dataSource={tabdata.datas.coworkList} size="small"/>;
            }
            viewType = tabdata.datas && tabdata.datas.viewType;
            typeid = tabdata.datas && tabdata.datas.typeid;
            status = tabdata.datas && tabdata.datas.status;
            jointype = tabdata.datas && tabdata.datas.jointype;
        }
        const _titleProps = {
            currentTab,
            config,
            titles,
            tabids,
            handleRefresh,
            handleDelete,
            viewType,
            typeid,
            status,
            jointype,
            fontSizeMp,
            tabwidth: esetting.tabwidth,
            methodvalue: esetting.methodvalue,
            handleTabData: this.handleTabData
        }
        return <div>
            <Title {..._titleProps}/>
            <div className="tabContant" id={`tabcontant_${eid}`} style={{height: cstyle.height}}>
                <Spin spinning={refresh}>{contentHtml}</Spin>
            </div>
         </div>;
    }
}

class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
            return ( <WeaErrorPage msg = { hasErrorMsg ? this.props.error : getLabel(385218,"对不起，该页面异常，请联系管理员！") }/>
        );
    }
}
CooperationCom = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(CooperationCom);
export default CooperationCom;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/cooperation/cooperation.js